export const PACK_DEFINITIONS = [
  {
    id: 'core',
    name: 'Core',
    description: 'Students workspace, basic incidents/safeguarding, documents, and base access.',
    locked: true
  },
  {
    id: 'safeguarding_pro',
    name: 'Safeguarding Pro',
    description: 'Advanced safeguarding workspace, action required view, and review schedules.'
  },
  {
    id: 'attendance',
    name: 'Attendance',
    description: 'Attendance workspace, thresholds, exports, and signals.'
  },
  {
    id: 'compliance',
    name: 'Compliance',
    description: 'Compliance workspace with missing document tracking and due KPIs.'
  },
  {
    id: 'inventory',
    name: 'Inventory',
    description: 'Inventory tracking, checkouts, overdues, repairs, and bulk actions.'
  },
  {
    id: 'messaging_assignments',
    name: 'Messaging & Assignments',
    description: 'Internal/external messaging, assignment hub, and submissions workflow.'
  },
  {
    id: 'student_portal',
    name: 'Student Portal',
    description: 'Student portal dashboard, journal, notifications, timetable, support.'
  },
  {
    id: 'rewards_points',
    name: 'Rewards & Points',
    description: 'Points rules, rewards thresholds, leaderboard, and student rewards UI.',
    dependsOn: ['student_portal']
  },
  {
    id: 'reports_pro',
    name: 'Reports Pro',
    description: 'Report builder workspace with XLS/ZIP exports.'
  }
];

export const DEFAULT_PACKS = {
  core: true,
  safeguarding_pro: true,
  attendance: true,
  compliance: true,
  inventory: true,
  messaging_assignments: true,
  student_portal: true,
  rewards_points: true,
  reports_pro: true
};

export const MODULE_PACK_MAP = {
  dashboard: 'core',
  students: 'core',
  incidents: 'core',
  'support-workers': 'core',
  broadcasts: 'core',
  settings: 'core',
  safeguarding: 'safeguarding_pro',
  attendance: 'attendance',
  compliance: 'compliance',
  inventory: 'inventory',
  messages: 'messaging_assignments',
  'external-messages': 'messaging_assignments',
  programmes: 'core',
  reports: 'reports_pro'
};

export const STUDENT_PORTAL_PACKS = {
  portal: 'student_portal',
  rewards: 'rewards_points'
};

export const normalizePacks = (packs = {}) => {
  const next = { ...DEFAULT_PACKS, ...packs, core: true };
  if (!next.student_portal) {
    next.rewards_points = false;
  }
  return next;
};
